import authentication from "@irati/auth"
import {getPaymentMethods} from "@irati/payments/services/Payments"
import {PaymentChannel, PaymentMethodType} from "@irati/types"

export const isPayPalAvailable = (currency: string): Promise<boolean> => {
  const getPaymentMethodsPayload = {
    channel: PaymentChannel.Web,
    locale: authentication.userLocale(),
    amount: 10, // Hardcoded value
    currency
  }
  return getPaymentMethods(getPaymentMethodsPayload).then((methods) => {
    return !!methods.find((method) => method.type === PaymentMethodType.Paypal)
  })
}
